exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-18990afa]{font-size:24px;margin-bottom:5px}.upload-files[data-v-18990afa]{margin-top:20px}", ""]);

// exports
